module.exports = __webpack_public_path__ + "img/MauritsHansen_portrett.c31124b4.jpg";